import titleIconTwo from '../../media/img/lab/chart-flask.png';

function Details(){
  return(
    <section className="details">
      <div className="details-title">
        <h3>Project Details</h3>
        <img src={titleIconTwo} className="title-icon"></img>
      </div>
      <h5>Description:</h5>
      <p className="mb-25 w-600px">
        Eternal September Lab is dedicated to understanding and utilizing AI technology in a holistic way. The initiative is designed to drive curiosity and learning, not simply create a final product. I will be covering heavy topics and complicated projects as well as silly, playful ones. I intend for these trials to be rigorous but whimsical, as is my nature. To better understand my motivation,<a href="https://dev.to/davesommerville/eternal-september-learning-for-the-life-of-it-i6i" target="_blank" rel="noopener noreferrer"> please read my psuedo-manifesto <span className="bold">here</span></a>
      </p>
      <h4 className="mb-25">Return Product: Optimized, Customized AI Agent</h4>
      <h5>Purposes:</h5>
      <ul className="mb-25">
        <li>- Project Management</li>
        <li>- Research assistant</li>
        <li>- Tutorial</li>
        <li>- Code Generation</li>
      </ul>
      <h5>Guidelines:</h5>
      <ul className="mb-25 w-600px">
        <li>- End to end ownership of final product</li>
        <li>- Rigorous research, experimentation, and documentation of entire project</li>
        <li>- Product designed with sustainability, ethics, and socio-economic impacts in mind</li>
      </ul>
    </section>
  );
}

export default Details;